// src/services/rtdbSobDemanda.js -- carrega o caminho RTDB so quando ele e' usado.
//
// Plano §2.1 / F2: `VUE_APP_GATE` e `VUE_APP_ATRIBUICAO` escolhem entre RTDB,
// sombra e API. Quando os DOIS estao em `api`, o SDK do Realtime Database nao
// pode nem chegar ao bundle (requisito da F5: desligar o Firebase e' apagar
// arquivos, nao caçar imports).

/**
 * Devolve `{ rtdb, calendario }` -- as pecas que so o caminho RTDB usa.
 *
 * A comparacao com as strings literais e' proposital: o DefinePlugin do vue-cli
 * troca `process.env.VUE_APP_*` por string constante, o ConstPlugin do webpack
 * dobra a condicao em tempo de compilacao e NAO cria as dependencias do ramo
 * morto -- sem chunk, sem SDK. Trocar 'api' por uma constante do modulo ou por
 * uma funcao `somenteApi()` quebra a dobra: o webpack nao propaga constantes
 * atraves de identificador nem de chamada (medido: o chunk rtdb voltava a sair).
 *
 * Exemplo:
 *   const { rtdb, calendario } = await carregarPecasDoRtdb();
 */
export async function carregarPecasDoRtdb() {
  if (process.env.VUE_APP_GATE !== 'api' || process.env.VUE_APP_ATRIBUICAO !== 'api') {
    const [rtdb, { calendarioSaoPaulo }] = await Promise.all([
      import(/* webpackChunkName: "rtdb" */ './rtdbCliente'),
      import(/* webpackChunkName: "rtdb" */ './calendarioSaoPaulo'),
    ]);
    return { rtdb, calendario: calendarioSaoPaulo };
  }
  throw new Error(
    `RTDB indisponivel: build feito com VUE_APP_GATE=${process.env.VUE_APP_GATE} e `
    + `VUE_APP_ATRIBUICAO=${process.env.VUE_APP_ATRIBUICAO}. Esperado: pelo menos um em rtdb|sombra.`);
}
